export const POPUPS_LEGACY_MODULE_NAME = '@pressreader/popups-legacy';
